import React, { createContext, useContext, useMemo } from 'react';
import { type BigQueryEvents, createEvents, BigQueryCommonProps } from './events';

const BigQueryContext = createContext<BigQueryEvents | null>(null);

export const useBigQuery = (): BigQueryEvents => {
  const bigQuery = useContext(BigQueryContext);
  if (!bigQuery) {
    throw new TypeError('useBigQuery must be used inside "BigQuery" root component');
  }
  return bigQuery;
};

interface BigQueryProps extends BigQueryCommonProps {
  children: React.ReactNode;
}

export const BigQuery = ({
  children,
  deliveryId,
  deliveryAttachmentType,
  gigId,
  sellerId,
  categoryId,
  subCategoryId,
  nestedSubCategoryId,
}: BigQueryProps) => {
  const events = useMemo<BigQueryEvents>(
    () =>
      createEvents({
        deliveryId,
        deliveryAttachmentType,
        gigId,
        sellerId,
        categoryId,
        subCategoryId,
        nestedSubCategoryId,
      }),
    [deliveryId, deliveryAttachmentType, gigId, sellerId, categoryId, subCategoryId, nestedSubCategoryId]
  );
  return <BigQueryContext.Provider value={events}>{children}</BigQueryContext.Provider>;
};
